// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"176":"fd5943c1","475":"c0cc3a11","987":"fd5943c1"}[chunkId] + ".chunk.css";
};